import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'gf-captcha',
  template: require('./captcha.html'),
})
export class GfCaptchaComponent {
  private _answer: string = '';

  @Input()
  get answer(): string {
    return this._answer;
  }
  set answer(value: string) {
    this._answer = value;
    this.answerChange.emit(value);
  }

  @Output() answerChange = new EventEmitter<string>();
  @Input() update: any;
  @Input() scheduleUpdate: any;
  
  captchaUrl = '/site/captcha';

  constructor() {
    this.refreshCaptcha();
    const scheduleRefresh = _.debounce(() => this.asyncRefresh(), 3600000);
    scheduleRefresh();
  }

  refreshCaptcha() {
    this.update = new Date().getTime();
    this.answer = '';
    this.scheduleRefresh();
  }

  asyncRefresh = () => {
    this.update = new Date().getTime();
    this.answer = '';
    this.scheduleRefresh();
  }

  scheduleRefresh() {
    var scheduleRefresh = _.debounce(() => this.asyncRefresh(), 3600000); //captcha is valid for 1 hour - request a new captcha if the old one times out
    scheduleRefresh();
  }

  onAnswerChange(value: string) {
    this.answer = value;
  }
}
